export default function Rating (props = {
    id: null,
    label: null,
    labelledby: null,
    describedby: null,
    values: [],
    name: null,
    required: false
}) {
    const {
        id,
        label,
        labelledby,
        describedby,
        defaultValue,
        children,
        ...inputProps
    } = props

    if (!id || !(inputProps || {}).name)
        return null

    const values = (props.values || []).length
        ? props.values
        : [1, 2, 3, 4, 5]

    return (
        <div
            id={id}
            className="rating"
        >
            {label
                && (
                    <p
                        id={`${id}-label`}
                        className="rating-label body-4 font-weight-normal margin-1-b"
                    >
                        {label}
                    </p>)}
            <div
                className="rating-group form-field"
                role="radiogroup"
                aria-labelledby={(label
                    && `${id}-label`)
                        || labelledby}
                aria-describedby={describedby}
            >
                {values
                    .map(value => (
                        <div
                            className="rating-group-item"
                            key={`${id}-rating-radio-${value}`}
                        >
                            <input
                                {...inputProps}
                                id={`${id}-${value}`}
                                type="radio"
                                value={value}
                                defaultChecked={defaultValue === value}
                            />
                            <label
                                htmlFor={`${id}-${value}`}
                                aria-label={`${value} out of ${values.length}`}
                            >
                                <span>{value}</span>
                            </label>
                        </div>
                    ))}
                {inputProps.required
                    && (
                        <p
                            role="alert"
                            className="margin-1-t"
                            id={`${id}-invalid`}
                        >
                            A rating is required
                        </p>)}
            </div>
        </div>
    )
}
